module.exports = __webpack_public_path__ + "img/ernest.m__600x600.808ee004.jpg";